import * as z from "zod/v4";

export const triggerRollupRebuild = {
  name: "triggerRollupRebuild" as const,
  input: z.object({
    teamIds: z.union([z.literal("all"), z.array(z.string())]),
    startDate: z.string(),
    endDate: z.string(),
  }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string().nullable(),
    accountCount: z.number().nullable(),
    error: z.string().nullable(),
  }),
};
